import React from 'react';
import { Card, CardContent, Typography, Box, Chip, Stack } from '@mui/material';
import ImageView from '@component/ImageView';
import { useTranslation } from 'react-i18next';

export default function ShopItemCard({ item }) {
    const {
        name,
        description,
        file_image,
        price_in_points,
        sold_quantity,
        max_available_quantity
    } = item;

    const { t } = useTranslation(["shop"]);
    const remainingStock = max_available_quantity - sold_quantity;

    return (
        <Card
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                cursor: 'pointer',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                p: 0,
                '&:hover': {
                    boxShadow: 3,
                },
            }}
        >
            <Box sx={{ position: 'relative' }}>
                <ImageView
                    fileUuid={file_image.uuid}
                    imageSx={{
                        height: "210px",
                        width: "100%",
                        objectFit: "cover",
                    }}
                />
            </Box>

            <CardContent sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: 'column',
                justifyContent: 'space-between',
                p: 2,
                pb: "8px !important"
            }}>
                <Box>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        {name}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        {description}
                    </Typography>
                </Box>

                <Box id="bottomStuffShopCard">
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ marginTop: "auto" }}>
                        <Chip
                            onClick={()=>{}}
                            label={t("shop:stockLeft", { count: remainingStock })}
                            size="small"
                            color={remainingStock > 0 ? "success" : "error"}
                        />
                        <Typography fontWeight="bold" color="primary">
                            {t("shop:pointsValue", { count: price_in_points })}
                        </Typography>
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    );
}
